import { useState, useEffect } from "react";
import outlawsLogo from "@/assets/outlaws-logo.webp";

interface IntroAnimationProps {
  onComplete: () => void;
}

export const IntroAnimation = ({ onComplete }: IntroAnimationProps) => {
  const [phase, setPhase] = useState<"enter" | "hold" | "exit">("enter");

  useEffect(() => {
    // Enter phase: 0.8s
    const holdTimer = setTimeout(() => setPhase("hold"), 800);
    // Hold phase: 1s, then exit
    const exitTimer = setTimeout(() => setPhase("exit"), 1800);
    // Complete after exit animation: 2.5s total
    const completeTimer = setTimeout(() => onComplete(), 2500);

    return () => {
      clearTimeout(holdTimer);
      clearTimeout(exitTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center">
      <div
        className={`
          transition-all duration-700 ease-out
          ${phase === "enter" ? "intro-logo-enter" : ""}
          ${phase === "hold" ? "intro-logo-hold" : ""}
          ${phase === "exit" ? "intro-logo-exit" : ""}
        `}
      >
        <img
          src={outlawsLogo}
          alt="ØUTLAWS"
          className="w-64 md:w-80 lg:w-96 h-auto"
        />
      </div>
      
      {/* Glitch overlay effect */}
      <div className={`absolute inset-0 pointer-events-none ${phase === "enter" ? "intro-glitch" : "opacity-0"}`} />
    </div>
  );
};
